import styled from 'styled-components';

import leafLogo from 'assets/images/sidebar-demo-leaf.svg';

import Icon from 'atoms/Icons/Icon';
import color from 'atoms/colors/colors';

import Link from 'quarks/Link';
import Text from 'quarks/Text';

const SidebarDemo = () => (
  <Container className="sidebar-demo">
    <Link href="/free-demo">
      <img src={leafLogo} alt="leaf-logo" />
      <Text as="p" fontSize="textSm" fontWeight="semiBold" textColor="gray-900">
        Get a FieldRoutes demo
      </Text>
      <Icon id="arrow-right" fill={color.gray[900]} size={16} />
    </Link>
  </Container>
);

export default SidebarDemo;

export const Container = styled.div`
  display: flex;
  justify-content: center;

  a {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-top: 40px;
    text-decoration: none;
  }
`;
